import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '@/components/Header';
import HeroSection from '@/components/HeroSection';
import DescriptionSection from '@/components/DescriptionSection';
import ReviewsSection from '@/components/ReviewsSection';
import FAQSection from '@/components/FAQSection';
import Footer from '@/components/Footer';
import WhatsAppButton from '@/components/WhatsAppButton';
import { trackViewContent, PRODUCT_DATA } from '@/lib/metaPixel';

const Buy: React.FC = () => {
  useEffect(() => {
    // Meta Pixel - ViewContent for Buy page
    trackViewContent({
      content_name: 'Buy Page - Class 10 Science Notes',
      content_category: 'Study Notes',
      content_ids: PRODUCT_DATA.content_ids,
      content_type: PRODUCT_DATA.content_type,
      value: PRODUCT_DATA.value,
      currency: PRODUCT_DATA.currency,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>Buy Toppers Notes - Class 10 Science Notes at ₹149 | TOPPERS BUDDY</title>
        <meta name="description" content="Buy best notes for class 10th science at just ₹149. Toppers short notes trusted by 1,300+ students. Get instant access to Physics, Chemistry, Biology notes for CBSE board exam 2025-2026." />
        <meta name="keywords" content="buy toppers notes, buy class 10 science notes, purchase toppers notes, class 10 notes price, best notes for class 10th science buy online" />
        <link rel="canonical" href="https://toppersbuddy.lovable.app/buy" />
        <meta property="og:title" content="Buy Toppers Notes - Class 10 Science Notes at ₹149" />
        <meta property="og:url" content="https://toppersbuddy.lovable.app/buy" />
      </Helmet>

      <div className="flex min-h-screen flex-col bg-background">
        <Header />
        <main role="main" aria-label="Buy Toppers Notes" className="flex-1">
          <HeroSection />
          <DescriptionSection />
          <ReviewsSection />
          <FAQSection />
        </main>
        <Footer />
      </div>
      
      <WhatsAppButton />
    </>
  );
};

export default Buy;
